module.exports = __webpack_public_path__ + "static/media/secure.52d2b52a.png";